::ng-deep app-apply-data-mapping-detail-view-dialog span.link-color{color:var(--accent, #175CFF)}
/*# sourceMappingURL=apply-data-mapping-detail-view-dialog.component-BJDZ25VQ.css.map */
